import angular from 'angular';
import controller from './name.controller';
import template from './name.html';
import NameComponent from './name.component';

const nameConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('name', {
		title:                  'Name',
		template,
		group:                  'advanced',
		children:               false,
		selectable:             true,
		settings:               new NameComponent(),
		icon:                   'fa fa-tags',
		views:                  [
			{
				name:     'Display',
				template: 'kform/components/name/display.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/common/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/name/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
		onEdit: /* @ngInject */ (
			/** @type {any} */ $scope,
			/** @type {import('angular').ITimeoutService} */ $timeout,
			/** @type {import('angular').translate.ITranslateService} */ $translate,
			/** @type {any} */ Notification,
		) => {
			$scope.tmp.name = {
				kid:         undefined,
				name:        undefined,
				displayLang: true,
			};

			$scope.langKid = $scope.class_kid;

			$scope.addLang = () => {
				if ($scope.component.langs.some((/** @type {any} */ l) => l.kid === $scope.tmp.name.kid)) {
					Notification.error({
						title:   $translate.instant('error.title'),
						message: $translate.instant('error.repre-already-exists'),
					});
				}
				else {
					$scope.component.langs.push({ ...$scope.tmp.name });
					$timeout(() => {
						$scope.tmp.name.kid = undefined;
						$scope.tmp.name.name = undefined;
						$scope.tmp.name.displayLang = true;
					});
				}
			};

			$scope.setLang = async (/** @type {any} */ item, /** @type {any} */ objectName) => {
				if (item?.name) {
					objectName.name = item.name;
				}
			};
		},
		controller,
	});
};

export default angular.module('app').config(nameConfig);
